import request from '@/utils/request'

export function getRoutes() {
  return request({
    url: '/BO/UserManage/GetRouters',
    method: 'get'
  })
}
export function fetchList(query) {
  return request({
    url: '/BO/Role/GetPaging',
    method: 'get',
    params: query
  })
}
export function fetchAllList(sid) {
  return request({
    url: '/BO/Role/GetAllList',
    method: 'get',
    params: { sid }
  })
}

export function fetchDetail(id) {
  return request({
    url: '/BO/Role/Get',
    method: 'get',
    params: { id }
  })
}

export function createEntity(data) {
  return request({
    url: '/BO/Role/Post',
    method: 'post',
    data
  })
}

export function updateEntity(data) {
  return request({
    url: '/BO/Role/Put',
    method: 'post',
    data
  })
}
export function deleteEntity(id) {
  return request({
    url: '/BO/Role/Delete',
    method: 'get',
    params: { id }
  })
}
export function GetPowerTree(id, roleId) {
  return request({
    url: '/BO/Role/GetPowerTree',
    method: 'get',
    params: { id, roleId }
  })
}
export function Authorize(data) {
  return request({
    url: '/BO/Role/RoleAuthoriza',
    method: 'post',
    data
  })
}

